module.exports = __webpack_public_path__ + "img/2.c016ede0.jpg";